var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 6C9.33333 6.67933 9.128 7.30933 8.77867 7.836L6.66667 5.724V2.734C8.188 3.04267 9.33333 4.38733 9.33333 6ZM5.33333 2.734C3.812 3.04267 2.66667 4.38733 2.66667 6C2.66667 7.84067 4.15933 9.33333 6 9.33333C6.67933 9.33333 7.30933 9.128 7.836 8.77867L5.33333 6.276V2.734ZM10.6667 4H13.3333V2.66667H10.6667V4ZM10.6667 6.66667H13.3333V5.33333H10.6667V6.66667ZM10.6667 9.33333H13.3333V8H10.6667V9.33333ZM8.66667 12V13.3333H12V14.6667H4V13.3333H7.33333V12H0V2C0 0.897333 0.897333 0 2 0H14C15.1027 0 16 0.897333 16 2V12H8.66667ZM1.33333 10.6667H14.6667V2C14.6667 1.63267 14.368 1.33333 14 1.33333H2C1.632 1.33333 1.33333 1.63267 1.33333 2V10.6667Z",
    fill: "#404651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.200fb41666121df07a04d7347339c783.svg";
export { ForwardRef as ReactComponent };